import React from 'react';

export default function Footer() {
  return (
    <footer className="border-t border-mentor-border/50 py-6 mt-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-mentor-muted font-body">
            Bond Mentor v1.0.0 — Complete Build
          </p>
          <p className="text-xs text-mentor-muted font-body text-center">
            Educational tool only. Not financial advice. Always consult a qualified financial advisor before making investment decisions.
          </p>
        </div>
      </div>
    </footer>
  );
}
